import React, {useEffect, useRef, useState} from 'react';
import axios from "axios";
import SendBirdCall from "sendbird-calls";

const ConversationChat = ({
                              openConversation,
                              authId,
                              authAvatar,
                              setOpenConversation,
                              handleSend,
                              setMessageText,
                              messageText,
                              role,
                              createCustomNotification,
                              closeAllNotifications,
                              onlineUsers,
                              disableCall
                          }) => {
    const selectedConversation = openConversation.data.selectedConversation;

    const startCall = async (isVideoCall) => {

        try {
            const isAuthor = selectedConversation.author_id == authId;

            const isCustomerOrUser = selectedConversation.is_customer === 1 ? 'customer_' + selectedConversation?.customer_user.customer_id : selectedConversation.user_id;
            const isToCustomerOrUser = selectedConversation.is_customer === 1 ? 'customer_' + selectedConversation?.customer_user.customer_id : selectedConversation.author_id;

            const calleeId = isAuthor
                ? isCustomerOrUser
                : isToCustomerOrUser;

            if (!calleeId) {
                alert("No user available for a call.");
                return;
            }
            const localView = document.getElementById('local_video_element_id');
            const remoteView = document.getElementById('remote_video_element_id');

            const call = await SendBirdCall.dial({
                userId: String(calleeId),
                isVideoCall: isVideoCall,
                callOption: {
                    localMediaView: localView,
                    remoteMediaView: remoteView,
                    audioEnabled: true,
                    videoEnabled: isVideoCall,
                },
            });

            call.muteMicrophone();
            const mute = () => {
                const micIcon = document.querySelector(".fa-microphone");
                const micSlashIcon = document.querySelector(".fa-microphone-slash");

                if (call.isLocalAudioEnabled) {
                    console.log('mute');
                    call.muteMicrophone();
                    micIcon.style.display = "none";
                    micSlashIcon.style.display = "inline-block";
                } else {
                    call.unmuteMicrophone();
                    console.log('unmute');
                    micIcon.style.display = "inline-block";
                    micSlashIcon.style.display = "none";
                }
            }

            const reject = () => {
                call.end();
                closeAllNotifications();
            }

            const startVideoCall = () => {
                const videoIcon = document.querySelector(".fa-video");
                const stopVideoIcon = document.querySelector(".fa-video-slash");

                if (call.isLocalVideoEnabled) {
                    call.stopVideo();
                    videoIcon.style.display = "none";
                    stopVideoIcon.style.display = "inline-block";
                } else {
                    call.startVideo();
                    videoIcon.style.display = "inline-block";
                    stopVideoIcon.style.display = "none";
                }
            };
            const calleeUser = calleeId == selectedConversation.to_user.id ? selectedConversation.to_user : selectedConversation.user;

            let callStartTime = null;
            let timerInterval;
            const videoButton = isVideoCall ? `<button class="btn start-call video-call">
                                    <i class="fas fa-video"></i><i class="fas fa-video-slash" style="display:none;"></i>
                                 </button>` : ``;

            const text = `
                <div style="padding:10px">
                    <div style="text-align: center; padding-bottom: 35px; padding-top: 40px">
                     <img src='${calleeUser?.avatar_image}' width="60" height="60" class="rounded-circle" alt="star-rating-svg-logo">
                      <br/>
                      <div style="font-weight: bold; font-size: large; margin-top: 10px">${calleeUser?.name}</div>
                      <div class="call-status">Ringing...</div>
                      <div class="call-timer" style="display:none">00:00</div>
                    </div>
                </div>
                <div class="transbox">
                    <div class="d-flex justify-content-between">
                       <button class="btn mute-call">
                            <i class="fas fa-microphone"></i><i class="fas fa-microphone-slash" style="display:none;"></i>
                       </button>
                       ${videoButton}
                       <button class="btn end-call">
                            <i class="fas fa-phone-slash"></i>
                       </button>
                    </div>
                </div>`;

            setTimeout(() => {
                document.querySelector(".mute-call")?.addEventListener("click", mute);
                document.querySelector(".end-call")?.addEventListener("click", reject);
                document.querySelector(".start-call")?.addEventListener("click", startVideoCall);
            }, 100);

            createCustomNotification({message: text, isVideoCall});

            call.onEstablished = () => {
                call.unmuteMicrophone();
                document.querySelector(".call-status").style.display = "none";
                document.querySelector(".call-timer").style.display = "inline-block";

                callStartTime = Date.now();
                timerInterval = setInterval(() => {
                    let elapsedTime = Math.floor((Date.now() - callStartTime) / 1000);
                    document.querySelector(".call-timer").innerText = formatTime(elapsedTime);
                }, 1000);
            };

            call.onEnded = () => {
                console.log("Call ended");
                const notificationContainer = document.getElementById("noty_layout__center");
                notificationContainer.style.display = 'none';
                closeAllNotifications();
                clearInterval(timerInterval);
            };

            function formatTime(seconds) {
                let minutes = Math.floor(seconds / 60);
                let secs = seconds % 60;
                return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
            }
        } catch (error) {
            console.error("Call error:", error);
        }
    };

    const closeChat = () => {
        setOpenConversation(false);
    }

    const deleteConversation = (conversation) => {
        let conversationId = conversation.data.selectedConversation.id;
        let url = `/${role}/general-chat/${conversationId}/delete-conversation`;

        axios.get(url, {
            data: JSON.stringify({conversationId: conversationId})
        })
            .then(() => {
                closeChat();
                window.location.reload();
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({behavior: "smooth"});
    };

    useEffect(() => {
        scrollToBottom();
        return () => {
        };
    }, [selectedConversation]);

    useEffect(() => {
        let messagePanel = document.getElementById(`sendMsg-${selectedConversation?.id}`);

        if (messagePanel) {
            messagePanel.scrollTo(0, messagePanel.scrollHeight);
        }
    }, [])

    const isCustomerOrUser = selectedConversation.is_customer === 1 ? selectedConversation.customer_user.user : selectedConversation.to_user;
    const isToCustomerOrUser = selectedConversation.is_customer === 1 ? selectedConversation.customer_user.user : selectedConversation.user;
    const isShowUser = selectedConversation.is_customer === 1 && selectedConversation.customer_user?.customer?.name;

    return (
        <div>
            <div className="p-2 mainChat">
                <div className="header border-bottom pb-2">
                    <div className="d-flex align-items-center w-100">
                        <div className="chat__area-header-avatar">
                            {selectedConversation?.is_group ? (
                                <img
                                    src="/images/group.jpg"
                                    className="rounded-circle"
                                    width={40}
                                    height={40}
                                    alt=""
                                />
                            ) : selectedConversation?.author_id == authId ? (
                                <a href="#" className="status-indicator-container conversation-img">
                                    <img
                                        src={isCustomerOrUser?.avatar_image}
                                        className="rounded-circle"
                                        width={40}
                                        height={40}
                                        alt=""
                                    />
                                    <span className={
                                        onlineUsers.includes(selectedConversation?.user_id)
                                            ? "status-indicator bg-success"
                                            : "status-indicator bg-danger"
                                    }
                                    />
                                </a>
                            ) : (
                                <a href="#" className="status-indicator-container conversation-img">
                                    <img
                                        src={isToCustomerOrUser?.avatar_image}
                                        className="rounded-circle"
                                        width={40}
                                        height={40}
                                        alt=""
                                    />
                                    <span
                                        className={
                                            onlineUsers.includes(selectedConversation?.user_id)
                                                ? "status-indicator bg-success"
                                                : "status-indicator bg-danger"
                                        }
                                        data-status-id={isToCustomerOrUser?.id}/>
                                </a>
                            )}
                        </div>
                        <div className="pl-2 text-truncate headerDetails">
                            {selectedConversation?.is_group ? (
                                <span className="text-gray h5">{openConversation.data.groupName}</span>
                            ) : selectedConversation?.author_id == authId ? (
                                <div>
                                    <div>
                                        <span
                                            className="text-gray font-size-lg">{isCustomerOrUser?.name}
                                            {isShowUser ? `(${isShowUser})` : ''}</span>
                                    </div>
                                    <div>
                                        <span
                                            className="text-muted text-sm">{isCustomerOrUser?.email}</span>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div>
                                        <span
                                            className="text-gray font-size-lg">{isToCustomerOrUser?.name}
                                            {isShowUser ? `(${isShowUser})` : ''}</span>
                                    </div>
                                    <div>
                                        <span className="text-muted text-sm">{isToCustomerOrUser?.email}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        {/*{disableCall == 0 && (*/}
                        {/*    <>*/}

                        {/*        <button className="custom-dial-button"*/}
                        {/*                onClick={() => startCall(false)}*/}
                        {/*        >*/}
                        {/*            <svg*/}
                        {/*                xmlns="http://www.w3.org/2000/svg"*/}
                        {/*                width="24"*/}
                        {/*                height="24"*/}
                        {/*                viewBox="0 0 24 24"*/}
                        {/*                fill="white"*/}
                        {/*            >*/}
                        {/*                <path*/}
                        {/*                    d="M6.62 10.79a15.093 15.093 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24 11.72 11.72 0 0 0 3.71.6 1 1 0 0 1 1 1v3.79a1 1 0 0 1-1 1A19.92 19.92 0 0 1 2 4a1 1 0 0 1 1-1h3.79a1 1 0 0 1 1 1 11.72 11.72 0 0 0 .6 3.71 1 1 0 0 1-.24 1.01l-2.2 2.2z"/>*/}
                        {/*            </svg>*/}
                        {/*        </button>*/}
                        {/*        <button className="custom-dial-button" onClick={() => startCall(true)}>*/}
                        {/*            <svg*/}
                        {/*                xmlns="http://www.w3.org/2000/svg"*/}
                        {/*                width="24"*/}
                        {/*                height="24"*/}
                        {/*                viewBox="0 0 24 24"*/}
                        {/*                fill="white"*/}
                        {/*            >*/}
                        {/*                <path*/}
                        {/*                    d="M17 10.5V7c0-1.1-.9-2-2-2H5C3.9 5 3 5.9 3 7v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-3.5l4 4v-11l-4 4z"/>*/}
                        {/*            </svg>*/}
                        {/*        </button>*/}
                        {/*    </>*/}
                        {/*)*/}
                        {/*}*/}

                        <div className="ml-auto d-flex align-items-center">
                            <ul className="navbar-nav navbar-nav-highlight">
                                <li className="nav-item dropdown">
                                    <a href="#" data-toggle="dropdown">
                                        <span className="mr-2 cursor-pointer text-black" id="dropdownDividerButton"
                                              data-dropdown-toggle="dropdownDivider">
                                            <i className="fas fa-ellipsis-h"/>
                                        </span>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <a href="#" className="dropdown-item"
                                           onClick={() => deleteConversation(openConversation)}
                                        >
                                            Delete
                                        </a>
                                    </div>
                                </li>
                            </ul>
                            <button id="closeDrawerBtn" type="button" className="close close-popup ml-2"
                                    onClick={closeChat}
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                </div>
                <ul id={`sendMessage-${selectedConversation?.id}`}
                    className="media-list media-chat media-chat-scrollable mb-3">
                    {openConversation.data?.conversationMessages &&
                    Object.entries(openConversation.data?.conversationMessages).map(([date, messages]) => (
                        <React.Fragment key={date}>
                            <li className="media content-divider justify-content-center text-muted mx-0">
                                {date}
                            </li>
                            {messages.map((message, index) => {
                                const isSender = message.from_id == authId;

                                if (isSender) {
                                    return (
                                        <li key={index} className="media media-chat-item-reverse">
                                            <div className="media-body">
                                                <i className="fa fa-trash text-muted cursor-pointer mr-2 btn-delete-msg"></i>
                                                <div
                                                    className="media-chat-item"
                                                    dangerouslySetInnerHTML={{__html: message.message}}
                                                />
                                                <div className="font-size-sm text-muted mt-2">
                                                    {message.date}
                                                </div>
                                            </div>
                                            <div className="ml-3">
                                                <a href={authAvatar}>
                                                    <img
                                                        src={authAvatar}
                                                        className="rounded-circle"
                                                        width="40"
                                                        height="40"
                                                        alt=""
                                                    />
                                                </a>
                                            </div>
                                        </li>
                                    );
                                }
                                const showMessage = selectedConversation.is_customer === 1 ? selectedConversation.customer_user.user : message.user;

                                console.log("selectedConversation",selectedConversation)
                                return (
                                    <div key={index} id={`recieveMsg-${selectedConversation?.id}`}>
                                        <li className="media">
                                            <div className="mr-3 mt-2">
                                                <a href="#"
                                                   className="status-indicator-container conversation-img">
                                                    <img
                                                        src={showMessage.avatar_image}
                                                        className="rounded-circle"
                                                        alt=""
                                                        width="40"
                                                        height="40"
                                                    />
                                                    <span
                                                        className={
                                                            onlineUsers.includes(selectedConversation?.user_id)
                                                                ? "status-indicator bg-success"
                                                                : "status-indicator bg-danger"
                                                        }/>
                                                </a>
                                            </div>
                                            <div className="media-body">
                                                <div>
                                                    <span>{showMessage.name}</span>
                                                    <span className="font-size-sm text-muted pl-1">
                                                  {showMessage.date}
                                                </span>
                                                </div>
                                                <div
                                                    className="media-chat-item"
                                                    dangerouslySetInnerHTML={{__html: message.message}}
                                                />
                                            </div>
                                        </li>
                                    </div>
                                );
                            })}
                        </React.Fragment>
                    ))}
                    <div ref={messagesEndRef}/>
                </ul>

                <div>
                 <textarea name="enter-message" className="form-control mb-2 txt-send-msg" rows="3"
                           cols="1" id={`txtSendMsg-${selectedConversation?.id}`}
                           placeholder="Type Message..."
                           value={messageText}
                           onChange={(e) => setMessageText(e.target.value)}
                 />
                    <div className="d-flex align-items-center">
                        <button type="button"
                                className="btn bg-color btn-labeled btn-labeled-right ml-auto btn-send-message-popup"
                                onClick={handleSend}>
                            <b><i className="icon-paperplane"/></b> Send
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConversationChat;
